import Rule from '../Rule'
import Rules from "../Rules";
import {DeviceConfig} from "../../services/DeviceConfigService/DeviceConfig";


export default class PT300Rules extends Rules {

  public lowtemperature: number;
  public hightemperature: number;
  public lowhumidity: number;
  public highhumidity: number;
  public lowpressure: number;
  public highpressure: number;
  public lowtempprobe: number;
  public hightempprobe: number;

  public highlight: number;
  public hightilt: number;
  public lowbatteryvolt: number;
  public lowbatterycap: number;


  constructor(data: any) {
    super(data);

    this.lowtemperature = data['lowtemperature'];
    this.hightemperature = data['hightemperature'];

    this.lowhumidity = data['lowhumidity'];
    this.highhumidity = data['highhumidity'];

    this.lowpressure = data["lowpressure"];
    this.highpressure = data["highpressure"];

    this.lowtempprobe = data["lowtempprobe"];
    this.hightempprobe = data["hightempprobe"];

    this.highlight = data["highlight"];
    this.hightilt = data["hightilt"];
    this.lowbatteryvolt = data["lowbatteryvolt"];
    this.lowbatterycap = data['lowbatterycap'];


    Array.from(DeviceConfig.getPT300RulesConfig().keys()).map((keyName: string) => {
      switch (keyName) {
        case 'temperature': {
          this.rules.push(new Rule('temperature', DeviceConfig.getPT300RulesConfig(), [this.lowtemperature, this.hightemperature]));
          break;
        }
        case 'humidity':{
          this.rules.push(new Rule('humidity',DeviceConfig.getPT300RulesConfig(), [this.lowhumidity, this.highhumidity]));
          break;
        }
        case 'lowbatterycap': {
          this.rules.push(new Rule('lowbatterycap', DeviceConfig.getPT300RulesConfig(), this.lowbatterycap));
          break;
        }
        case 'tempprobe': {
          this.rules.push(new Rule('tempprobe', DeviceConfig.getPT300RulesConfig(), [this.lowtempprobe, this.hightempprobe]));
          break;
        }
        case 'pressure':{
          this.rules.push(new Rule('pressure', DeviceConfig.getPT300RulesConfig(), [this.lowpressure, this.highpressure]));
          break;
        }
        case 'highlight':{
          this.rules.push(new Rule('highlight', DeviceConfig.getPT300RulesConfig(), this.highlight));
          break;
        }
        case 'hightilt': {
          this.rules.push(new Rule('hightilt', DeviceConfig.getPT300RulesConfig(), this.hightilt));
          break;
        }
        case 'lowbatteryvolt': {
          this.rules.push(new Rule('lowbatteryvolt', DeviceConfig.getPT300RulesConfig(), this.lowbatteryvolt));
          break;
        }
      }
    });
  }
}
